import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {openCategory} from '../actions/categories';
import MyApp from '../components/My-app';
import {fetchMyAppsIfNeeded} from '../actions/apps-by-type';

class MyApps extends React.Component {

  componentDidMount() {
    this.props.dispatch(fetchMyAppsIfNeeded());
  }

  componentWillMount() {
    this.props.dispatch(openCategory('my-apps'));
  }

  render() {
    return (
      <div className="short-header-page secondary-inner-page">

        <div className="section section-pad section-vertical-pad">
          <h1 className="title">My apps</h1>
        </div>

        {this.props.isFetching ?
          <div className="circle-loader"></div> :

          <div className="section section-pad">
            <div className="my-apps-container">
              {this.props.apps.map((app, i) =>
                <MyApp app={app} key={app.appDefinitionId} biPosition={i + 1}/>
              )}
            </div>
          </div>
        }
      </div>
    );
  }
}

MyApps.propTypes = {
  apps: PropTypes.array.isRequired,
  isFetching: PropTypes.bool,
  dispatch: PropTypes.func
};


function mapStateToProps(state) {
  // holds another kind of app data state.mode.metaSiteApps.items
  return {
    apps: state.appsByType.myApps.items,
    isFetching: state.appsByType.myApps.isFetching
  };
}

export default connect(mapStateToProps)(MyApps);



// WEBPACK FOOTER //
// ./containers/My-apps.js